module.exports = __webpack_public_path__ + "static/ArdeviaLogo_white-ff876793bf57cfc323eada98e37ac5f9.png";